import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgPhone = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12.854 1.815a7.294 7.294 0 0 1 2.847.139 7.231 7.231 0 0 1 3.362 1.908 7.23 7.23 0 0 1 1.908 3.362c.234.93.28 1.9.14 2.848a1 1 0 0 1-1.979-.295 5.293 5.293 0 0 0-.1-2.066 5.23 5.23 0 0 0-1.383-2.435 5.231 5.231 0 0 0-2.434-1.382 5.294 5.294 0 0 0-2.066-.1 1 1 0 0 1-.295-1.979Z" />
      <path d="M13.032 5.262a3.885 3.885 0 0 1 3.326 1.097 3.885 3.885 0 0 1 1.097 3.326 1 1 0 0 1-1.989-.179l.01-.116a1.885 1.885 0 0 0-.532-1.617 1.883 1.883 0 0 0-1.44-.55l-.177.017a1 1 0 1 1-.295-1.978ZM6.923 3.235H4.48c-1.927 0-3.31 1.826-2.692 3.655 1.219 3.612 2.858 6.812 4.995 8.95 2.138 2.138 5.338 3.777 8.95 4.996 1.83.617 3.655-.766 3.655-2.693v-2.444c0-.712-.386-1.37-1.01-1.716L16.25 12.8l-.157-.078a1.963 1.963 0 0 0-1.675.038l-1.933.966-.033-.01a5.896 5.896 0 0 1-1.664-.86 5.093 5.093 0 0 1-1.026-1.028 5.773 5.773 0 0 1-.77-1.409l-.09-.256-.011-.033.967-1.931c.29-.58.274-1.265-.04-1.831L8.64 4.246a1.963 1.963 0 0 0-1.717-1.01Zm-.021 2L8.06 7.321 6.934 9.575a1 1 0 0 0-.088.638c.144.736.536 1.772 1.313 2.812a7.104 7.104 0 0 0 1.429 1.431c1.043.782 2.08 1.174 2.82 1.316l.13.016a1 1 0 0 0 .505-.104l2.252-1.127 2.092 1.163v2.423c0 .584-.507.969-1.014.797-3.345-1.128-6.306-2.645-8.176-4.514-1.87-1.87-3.386-4.83-4.514-8.176-.172-.507.213-1.015.797-1.015h2.422Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgPhone)
const Memo = memo(ForwardRef)
export default Memo
